import { Button } from 'reactstrap'
import { primary_color } from '../../../Helper/uiHelper'

import "./consent.scss"

const Consent = ({ title, disabled, onNo, onYes, containedNoButton, containedYesButton }) => {
  return (
    <div className='raise-ticket-consent'>
      <div className='h2 font-weight-bold mb-5 mt-3' style={{ color: primary_color }}>
        {title}
      </div>
      <div className='d-flex action-wrapper'>
        <Button
          disabled={disabled}
          className='subtitle1 mr-4 py-3 no-btn'
          color='danger'
          outline={!containedNoButton}
          style={{ borderRadius: '50rem', width: '100%' }}
          onClick={onNo}>
          No
        </Button>
        <Button
          disabled={disabled}
          className='subtitle1 py-3'
          style={{ background: primary_color, borderRadius: '50rem', width: '100%' }}
          onClick={onYes}
          outline={!containedYesButton}
          color='primary'>
          Yes
        </Button>
      </div>
    </div>
  )
}

export default Consent
